export default __webpack_public_path__ + "static/media/P20001.9a38fe77.png";